import { effects } from 'redux-saga'

import {
  setSiteContactFirstName,
  setSiteContactLastName,
  setSiteContactNumber,
} from '../../modules/signupEdit/actions'
import { selectEditSignupWithExternals } from '../../modules/signupEdit/selectors'

export default function* setSiteContact() {
  const state = yield effects.select()
  const signupWithExternals = yield effects.call(
    selectEditSignupWithExternals,
    state,
  )

  if (signupWithExternals.signup.siteContactFirstName || signupWithExternals.signup.siteContactLastName) {
    return
  }

  if (!signupWithExternals.product.addressRequired) {
    return
  }

  const user = signupWithExternals.user

  yield effects.put.resolve(
    setSiteContactFirstName(
      user ? user.first_name : signupWithExternals.signup.firstName,
    ),
  )
  yield effects.put.resolve(
    setSiteContactLastName(
      user ? user.last_name : signupWithExternals.signup.lastName,
    ),
  )
  yield effects.put.resolve(
    setSiteContactNumber(
      user ? user.numbers.first() : signupWithExternals.signup.contact,
    ),
  )
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/setSiteContact.js